import React from 'react';

const DividerWidget = () => (
  <hr className="news-article-body-divider"/>
);

DividerWidget.mapProps = (/*props*/) => ({});
DividerWidget.propTypes = {}

export default DividerWidget;



// WEBPACK FOOTER //
// ./modules/News/components/widgets/Divider.widget.js